<template>
  <footer class="footer animated fadeIn fadeout" v-if="!mainMenuOpenIsOpen">
    <div class="footer-inner" >
      <p>
        © {{ new Date().getFullYear() }} TANM. All rights reserved.
      </p>
      <nav class="footer-links">
        <RouterLink to="/about">About</RouterLink>
        <RouterLink to="/cookie-policy">Cookie Policy</RouterLink>
        <RouterLink to="/privacy">Privacy Policy</RouterLink>
        <RouterLink to="/terms">Terms and Conditions</RouterLink>
        <RouterLink to="/sign-up">Join Waitlist</RouterLink>
        <RouterLink to="/vendor-signup">Partner With Us</RouterLink>
      </nav>
    </div>
  </footer>
</template>

<script setup>
  import { inject, onMounted, ref, watch } from 'vue'
  const uiState = inject('uiState')
  const mainMenuOpenIsOpen = ref(false)

  // or reactively watch:
  watch(() => uiState.mainMenuOpen, val => {
    mainMenuOpenIsOpen.value = val
  })
</script>

<style scoped>
  .footer {
    background-color: #25004d;
    color: #ddd;
    padding: 30px 20px;
    text-align: center;
    font-size: 14px;
    margin-top: 60px;
    margin-bottom: -0vw;
    /*padding-bottom: 50px;*/
    z-index: 50;
  }
  

  .footer-inner {
    max-width: 900px;
    margin: 0 auto;
  }

  .footer-links {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 12px;
  }

    .footer-links a {
      color: #ddd;
      text-decoration: none;
      font-weight: 500;
      transition: color 0.2s ease;
    }

      .footer-links a:hover {
        color: white;
        text-decoration: underline;
      }

</style>
